(function () {
    'use strict';

    realmCommerceApp.controller("SearchFormController", SearchFormController);

    /*@ngInject*/
    function SearchFormController(apiService) {
        let vm = this;
        vm.search = {
            term: '',
            isLoading: false,
            results: null
        };

        vm.search = search;

        activate();

        function activate() {
        }

        function search() {
            return apiService.autocomplete(vm.search.term).then(response => {
                return response.data.map(item => {
                    return {
                        url: item.url,
                        name: item.label,
                        image: item.image,
                    };
                });
            });
        }
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/search/search-form.controller.js